/* eslint-disable react/prop-types */
/* eslint-disable no-empty */
/* eslint-disable no-param-reassign */
/* eslint-disable linebreak-style */
import React, { useState, useEffect } from "react";

import "src/assets/css/stimulsoft.viewer.office2013.whiteblue.css";
import { LinearProgress } from "@material-ui/core";
import useAuth from "src/hooks/useAuth";

function StReportViewer({
    reportPath, stopExport, reportDataSet, filterCriteria, reportTitle,
    removeBackGroundColors, setShowStyleButton, fixedDirection
				 
			  
}) {
  const [stiReportsScriptLoaded, setStiReportsScriptLoaded] = useState(
    window.Stimulsoft
  );
  const [stiViewerScriptLoaded, setStiViewerScriptLoaded] = useState(
    window.Viewer
  );

  const [isLoading, setIsLoading] = useState(true);

  const afterScriptLoaded = () => {
    window.Stimulsoft.Base.StiLicense.loadFromFile("/stimulsoft/license.key");

    window.Stimulsoft.Base.Localization.StiLocalization.setLocalizationFile(
      "/stimulsoft/localization/en.xml",
      true
    );

    const report = window.Stimulsoft.Report.StiReport.createNewReport();
    // report.loadFile('/reports/SubRunning_modifed.mrt');
    report.loadFile(
      reportPath.startsWith("/") ? reportPath : `/${reportPath}?${Date.now()}`
    );
    // report.dictionary.variables.getByName('LogoUrl').valueObject = '/reports/Logo.jpg';
    let isRtl = false;
    try {
      const APP_LANG = localStorage.getItem("APP_LANG");
      const direction = APP_LANG === "ar" ? "rtl" : "ltr";
      isRtl = direction === "rtl";
    } catch {}
    //TEMP  const { user: currentUser } = useAuth();
    const currentUser = { userProfile: {} };
    const userName =
      currentUser.userProfile && currentUser.userProfile.fullName
        ? currentUser.userProfile.fullName
        : "Unknown User";
    report.dictionary.variables.list.forEach((element) => {
      const name = element.getName();
      switch (name.toLowerCase()) {
        case "logourl":
          element.valueObject = "/reports/Logo.jpg";
          break;
        case "title":
          element.valueObject = reportTitle;
          break;
        case "headerline1":
          element.valueObject =
            currentUser &&
            currentUser.userProfile &&
            currentUser.userProfile.reportsHeaderLine1
              ? currentUser.userProfile.reportsHeaderLine1
              : "";
          break;
        case "headerline2":
          element.valueObject =
            currentUser &&
            currentUser.userProfile &&
            currentUser.userProfile.reportsHeaderLine2
              ? currentUser.userProfile.reportsHeaderLine2
              : "";
          break;
        case "headerline3":
          element.valueObject =
            currentUser &&
            currentUser.userProfile &&
            currentUser.userProfile.reportsHeaderLine3
              ? currentUser.userProfile.reportsHeaderLine3
              : "";
          break;
        case "footerdata":
          element.valueObject = isRtl
            ? `طبع بواسطة : ${userName}    تاريخ الطباعة : ${new Date()
                .toISOString()
                .replace("T", " ")
                .slice(0, 19)}`
            : `Printed By : ${userName}    Print Date : ${new Date()
                .toISOString()
                .replace("T", " ")
                .slice(0, 19)}`;

          break;
        default:
          if (filterCriteria[name]) {
            if (
              typeof filterCriteria[name] === "object" &&
              filterCriteria[name].hasOwnProperty("textField") &&
              filterCriteria[name].textField
            ) {
              element.valueObject = filterCriteria[name].textField;
            } else {
              element.valueObject = filterCriteria[name];
            }
          }
          break;
      }
    });
    report.pages.list.forEach((page) => {
      page.components.list.forEach((component) => {
         //#region
        if (!fixedDirection) {
          if (
            isRtl &&
            component.horAlignment === 0 /*0=Left 1=center  2=right 3=width */
          ) {
            component.horAlignment = 2;
          }
          if (
            isRtl &&
            component.textOptions &&
            !component.textOptions.rightToLeft
          ) {
            component.textOptions.rightToLeft = true;
          }
          if (
            component.components &&
            component.components.list &&
            component.components.list.length
          ) {
            const parentWidth = component.width;

            component.components.list.forEach((subComponent) => {
              if (
                isRtl &&
                subComponent.horAlignment ===
                  0 /*0=Left 1=center  2=right 3=width */
              ) {
                subComponent.horAlignment = 2;
              }
              if (
                isRtl &&
                subComponent.textOptions &&
                (subComponent.horAlignment === 2 ||
                  !subComponent.textOptions.rightToLeft)
              ) {
                //subComponent.textOptions.rightToLeft = true;
              }
              if (isRtl && subComponent.alias) {
                subComponent.text = subComponent.alias;
              }

              //#region  Reposition controls
              if (isRtl) {
                const oldLeft = subComponent.left;
                const oldWidth = subComponent.width;
                subComponent.setLeft(parentWidth - oldLeft - oldWidth);
              }
              //#endregion
            });
          }
        }
        //#endregion
      });
    });

    const dataSet = new window.Stimulsoft.System.Data.DataSet("Demo");
    console.log("Before dataSet.readJson(reportDataSet", new Date());
    dataSet.readJson(reportDataSet); //هي دي اللى بتاخد وقت طويل
    console.log("After dataSet.readJson(reportDataSet", new Date());
    // Remove all connections from the report template
    report.dictionary.databases.clear();
    // Register DataSet object
    report.regData("Demo", "Demo", dataSet);
    const options = new window.Stimulsoft.Viewer.StiViewerOptions();
    //TODO MAKE IT OPTION FROM INVOICE
    if (stopExport) {
      options.exports.showExportDialog = false;
      options.exports.showExportToCsv = false;
      options.exports.showExportToDocument = false;
      options.exports.showExportToExcel2007 = false;
      options.exports.showExportToHtml = false;
      options.exports.showExportToHtml5 = false;
      options.exports.showExportToImageSvg = false;
      options.exports.showExportToJson = false;
      options.exports.showExportToOpenDocumentCalc = false;
      options.exports.showExportToPowerPoint = false;
      options.exports.showExportToOpenDocumentWriter = false;
      options.exports.showExportToWord2007 = false;
      options.exports.showExportToText = false;
    }

    window.viewer = new window.Stimulsoft.Viewer.StiViewer(
      options,
      "StiViewer",
      false
    );

    window.viewer.report = report;
    setIsLoading(false);
    window.viewer.onInteraction = function (args) {
      console.log(args.action);
      // switch (args.action) {

      // case "Sorting":

      // break;

      // case "DrillDown":

      // break;

      // case "Collapsing":

      // break;

      // }
    };
    window.viewer.renderHtml("viewerContent");
    if (window?.HIDE_PRINT_WITH_PREVIEW) {
      window.viewer.jsObject.controls.menus.printMenu.items[
        "PrintWithoutPreview"
      ].style.display = "none";
      var printPdfButton =
        window.viewer.jsObject.controls.menus.printMenu.items["PrintPdf"];
      printPdfButton.innerHTML = printPdfButton.innerHTML.replace(
        "PDF",
        "Print Preview"
      );
      const pdfImg =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAAV9JREFUeNpi/GhvvJeBgcGJgTywjwWmme/AGbDIzwWzwBjE/3vrOsPvzesZfm1eB5cHgU8OJjCmExOycSAJ9oQ0OP9rWiwDR3EVnA8yGEkzGKAYALIFpAgXYLGyxRRDdwEy4J61mOFHbxuKi9ABIzAQ/zNQArZt2/afXLBj08b/cC+8fPmaoGXi4qIIzr9/DOobVyHCAEWSCPBjYheD0J0bDGS54OfC2Qy/Nq5BjQViXPD/zSuG710tDH9OHUNEo8r2DQz/NNUZXnPy4rT1/4f3DL93bQPb/P/rFwYWCxsGVjcvhv2fviKi8b+YBMM/LV2Gf+JSwBTFD4njp48YON69Yfhz4giELyLGwFlSBTYABLZv347wAuOrFwzMIIzmgj8wp5pZMXA2djAwcnLhTom4AFtgGANHbgkw4TNhJuVnpta3pE4fVcMaaIxMDPddvBieq+kyMOzciU3JDoAAAwD7hrc/fOGblwAAAABJRU5ErkJggg==";
      //  const previewImg="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3ZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiODNkYzY1ZS04MmI3LTZkNDUtODdhNy1kNmI1NGI3ODllYjYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MUI0ODlDNTNGNDNGMTFFOThGNzBFMkZERkZCQjc3NkMiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MUI0ODlDNTJGNDNGMTFFOThGNzBFMkZERkZCQjc3NkMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6NzU3ZDQ0OTItMDE5NC00ZjQ2LTkyM2EtYmFhODJlZjE3ZTEzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOmI4M2RjNjVlLTgyYjctNmQ0NS04N2E3LWQ2YjU0Yjc4OWViNiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PjaYViAAAAFeSURBVHjaYvz//z8DJYAFRHR1deEyZS4QpwLx/7KyMtwGgAC6AqChDIaGhsnnz5//CuTm43IBEz7nOTs7gwzJAzLb8HoBF+jp6YExK4G4iiQDkL0E8s72O+9Q5D1VhAi7YOuR0wznThxl+P/zF8OlTYt/8InLTFcwdywkKgy2Hz3LcPzcRYYv0voMJuHpDArmTux/fv8seHByfz9RBpw5fpjht6gywx9eUQZGJmYGPnFpBjFVXYZPL59kEmXAv2+fGf7wCKOI8YpKMPz8+pmdqEDk5hdk0ACGE5+4FFzsy5sXDOzcvD8vr5vDcJmQC6xs7Rhe3brM8PnVU4b///6B6afnjzKwsrGex+oCUFQhAwkJCQYJEVGG+yf3M/z48pGBjYv3Jxs724U/375YAKXrgbgRpI4RW2ZCj3MQADkbChqgBoDoRqxhAEskKAYgmA1IdCMTmbkYpJkRxAAIMABI53bqRFcorgAAAABJRU5ErkJggg=="
      const printImg =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABGdBTUEAAK/INwWK6QAAAK1JREFUeNpiLCoqYkAD/xnwA0ZkDgs2Fb29vVh1FhcXY4gxMVAIKDYA5AV7IO4CYjOQ0/2ad4IxViDgxrCp1v0/1CungLgMZMAKIJaAqQEqINZyM5BeFmTN2AKJAJAY+ECkSiw8BWJpMhPSU5ABKUA8HzkwQcC3aQeKys11HuiaX4D0ggwAqZSE2Qy05T8ODTDXMSK7hAWX34hwAaYByCbj0oAeDizE5jpcACDAAGpKMV9jbBb4AAAAAElFTkSuQmCC";
      printPdfButton.innerHTML = printPdfButton.innerHTML.replace(
        pdfImg,
        printImg
      );
      window.viewer.jsObject.controls.menus.printMenu.items["PrintPdf"] =
        printPdfButton;
    }
  };

  const loadStiReportsScript = () => {
    const script = document.createElement("script");
    script.src = "/stimulsoft/stimulsoft.reports.pack.js";
    script.onload = function () {
      setStiReportsScriptLoaded(true);
    };
    script.async = true;
    document.body.appendChild(script);
  };

  const loadStiViewerScript = () => {
    const script = document.createElement("script");
    script.src = "/stimulsoft/stimulsoft.Viewer.pack.js";
    script.onload = function () {
      setStiViewerScriptLoaded(true);
    };
    script.async = true;
    document.body.appendChild(script);
  };

  useEffect(() => {
    if (!window.Stimulsoft) {
      loadStiReportsScript();
      loadStiViewerScript();
    } else {
      setStiReportsScriptLoaded(true);
    }
    if (window.Stimulsoft && !window.Stimulsoft.Viewer) {
      loadStiViewerScript();
    } else {
      setStiViewerScriptLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (stiReportsScriptLoaded && stiViewerScriptLoaded) {
      afterScriptLoaded();
    }
  }, [stiReportsScriptLoaded, stiViewerScriptLoaded]);

  useEffect(() => {
    if (stiReportsScriptLoaded && stiViewerScriptLoaded) {
      afterScriptLoaded();
    }
  }, [reportDataSet]);
  return (
    <>
      {isLoading && <LinearProgress />}
      <div id="viewerContent" style={{ direction: "ltr" }} />
    </>
  );
}

export default StReportViewer;
